import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Component, OnInit, Input, Output, ElementRef, EventEmitter,ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { DropdownService } from 'projects/services/src/app/API/dropdown.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { AadhaarService } from 'projects/services/src/app/API/aadharService/aadhaar.service';

@Component({
	selector: 'app-trainer-personal-info',
	templateUrl: './personal-info.component.html',
	styleUrls: ['./personal-info.component.css']
})
export class TrainerPersonalInfoComponent implements OnInit, AfterViewInit {
	@Input() group: FormGroup;
	@ViewChild('dob') dob: ElementRef;
	@Input() firstTimeLoad: boolean;
	@Output() isVerified = new EventEmitter();
	@Input() isAadharVerified: boolean;
	isCandidate: any = false;
	temp: any = {};
	dateObject = { date: null, placeholder: 'dd/MM/yyyy', format: 'dd/MM/yyyy' };
	fileTypeErrorInDisabilityProof = false;
	fileTypeErrorInIdentityProof = false;
	fileTypeErrorInPhoto = false;
	type: boolean;
	localFileName: any= {aadharDoc: '', identityfile: '', alternateIdDoc: ''};
	// localFileName: {aadharDoc: string, identityfile: string,alternateIdDoc: string} = {aadharDoc: '', identityfile: '', alternateIdDoc: ''};
	sizeErrorInPhoto = false;
	public genderOptions = [];
	public languageOptions = [];
	public namePrefixOptions = [];
	public religionOptions = [];
	public categoryOptions = [];
	public disabilityTypeOptions = [];
	public relationWithGuardianOptions = [];
	public maritialStatusOptions = [];
	public alternateIdTypeOptions = [];
	public casteOptions = [];
	loggedInUser: any;
	currentUserInfo: any = {};
	currentUserPersonalDetails: any = {};
	currentUserFirstName: any;
	aadharNumber = '';
	formLoaded=false;
	adharValidation = {
		isAadhaarVerified : false,
	  aadharNumber:''
	};
	public disabilityFile = {
		name: 'Upload Disability Proof'
	};
	public identificationFile = {
		name: 'Upload Document Proof'
	};
	public photoFile = {
		name: 'Upload Your Photo'
	};
	constructor(private _script: ScriptLoaderService,
		private dropdownService: DropdownService,
		private currentUserService: CurrentUserService,
		private adhaarService: AadhaarService) { }



	ngOnInit() {
		// this._script.addScriptTagToElementDOM('../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js');
		this.loggedInUser = this.currentUserService.decodeToken();
		this._getCurrentUser();
		this.getGenderOptions();
		this.getReligionOptions();
		this.getCatseOptions();
		this.getDisabilityTypeOptions();
		this.getNamePrefixOptions();
		this.getRelationWithGuardianOptions();
		this.getMaritialStatusOptions();
		this.getAlternateIdTypeOptions();
		this.firstTimeLoad = false;
	}
	ngAfterViewInit() {
		this._script.loadScripts('app-trainer-personal-info',
			['../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js']);
	}


	isDisabled() {
		if (this.currentUserInfo.role === 'Candidate') {
			return this.isCandidate ? 'true' : 'false';
		}
	}

	_getCurrentUser() {
		console.log('Current User');
		this.currentUserService.getAdditionalInfomartion().subscribe(loggedInUser => {
			this.currentUserInfo = loggedInUser;
			this.formLoaded = true;
			const date = loggedInUser.personalDetails.dob;

			this.group.get('personalDetails').get('dob').patchValue(// date
				Helpers.toCalendarDate(date)
			);


		// }
		console.log(loggedInUser.personalDetails.aadharNumber);


	});

	}

	// getCurrentUserAdditionalInfo() {
	// 	this.currentUserService.getAdditionalInfomartion().subscribe(
	// 		res => {
	// 			this.currentUserInfo = res;
	// 			this.currentUserPersonalDetails = this.currentUserInfo.personalDetails;
	// 		},
	// 		error => {
	// 			console.log(`Error in fetching data. ${error}`);
	// 		}
	// 	);
	// }

	getNamePrefixOptions() {
		this.namePrefixOptions = ['Mr.', 'Mrs.', 'Ms.','Mx.'];
	}
	getMaritialStatusOptions() {
		this.maritialStatusOptions = [
			{ code: 1, name: 'Never Married' },
			{ code: 2, name: 'Married' },
			{ code: 3, name: 'Widow / Widower' },
			{ code: 4, name: 'Divorced' },
			{ code: 5, name: 'Separated' },
		];
	}
	getRelationWithGuardianOptions() {
		this.relationWithGuardianOptions = ['Mother', 'Father', 'Guardian'];
	}
	getGenderOptions() {
		this.genderOptions = ['Female', 'Male', 'Other'];
	}
	selectPrefix(value){
		if (value === "Ms." || value === "Mrs."){
			this.group.get('personalDetails').get('gender').setValue('Female');
		}else if (value === "Mr.") {
			this.group.get('personalDetails').get('gender').setValue('Male');
		}else if (value ==="Mx.") {
			this.group.get('personalDetails').get('gender').setValue('Transgender');
		}

	}
	getCatseOptions() {
		this.dropdownService.getCategory().subscribe(
			res => {
				this.casteOptions = res;
			}, error => {
				console.log(`Error in fetching caste Options ${error}`);

			}
		);
		// this.casteOptions = ['OC', 'BC', 'SC', 'ST', 'Minority'];
	}
	getAlternateIdTypeOptions() {
		this.alternateIdTypeOptions = [
			// 'Aadhaar Card',
			'Birth Certificate issued by govt.',
			'BPL Card',
			'Domicile Certificate',
			'Driving License',
			'Identity proof by Gazetted officers',
			'Jail Identification Card / Number',
			'Letter of domicile from SDM / DM / Govt. authority',
			'National Population Register (NPR) Card',
			'Permanent Residential Certificate (PRC)',
			'Passport',
			'PAN Card',
			'Ration Card',
			'ST/SC Certificate',
			'School leaving certificate / 10th certificate',
			'Voter ID Card',

		];
	}

	getReligionOptions() {
		this.dropdownService.getReligions().subscribe((religions) => {
			this.religionOptions = religions;

		}, error => {
			console.log(`There was error fetching religions :${error}`);
		});
	}
	getDisabilityTypeOptions() {
		this.dropdownService.getDisabilityTypes().subscribe((disabilityTypes) => {
			this.disabilityTypeOptions = disabilityTypes;
		}, error => {
			console.log(`There was error fetching category :${error}`);
		});
	}

	validate() {

	}

	// onDateChange(event) {
	// 	this.dateObject.date = new Date(event);
	// 	this.group.get('personalDetails').get('dob').setValue(this.dateObject.date);
	// }
	setDOB(event) {
		console.log(event.target.value);

		if (event && event.target && event.target.value) {
			this.group.get('personalDetails').get('dob').setValue(event.target.value);
			console.log(this.group.get('personalDetails').get('dob').value);
		}
	}

	setDisabilityValidation(value) {
		console.log(value);
			if (value === true) {
			this.group.get('personalDetails').get('disabilityCategory').setValidators([Validators.required]);
			this.group.get('personalDetails').get('disabilityDoc').setValidators([ Validators.required, ValidationService.fileValidator,  ValidationService.fileSizeValidator(5), ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'), ValidationService.fileSizeValidator(5)]);
		 }else {
			 this.group.get('personalDetails').get('disabilityCategory').setValue('');
			 this.group.get('personalDetails').get('disabilityDoc').setValue('');
			 	this.localFileName.disabilityDoc = '';
				 if (this.currentUserInfo.personalDetails) {
					this.currentUserInfo.personalDetails.disabilityDoc = false;
				 }
				this.group.get('personalDetails').get('disabilityCategory').setValidators([]);
				this.group.get('personalDetails').get('disabilityCategory').updateValueAndValidity();
			this.group.get('personalDetails').get('disabilityDoc').setValidators([]);
		     this.group.get('personalDetails').get('disabilityDoc').updateValueAndValidity();
		 }
	}
	aadharValidate() {
		if (!this.adharValidation.isAadhaarVerified){
			this.adhaarService.validateAdhaarNumber(this.aadharNumber)
			.subscribe(res => {
				if (res) {
					console.log(res);
					if (res) {
						this.adharValidation.isAadhaarVerified = true;
						this.adharValidation.aadharNumber = res.aadharEncryptedValue;
						this.isVerified.emit(this.adharValidation);
						this.group.get('personalDetails').get('aadharNumber').setValue(res.aadharEncryptedValue);
					}

				}
			});
		}

	}
	getAdharNumber(_key) {
		console.log(typeof _key);
		if (_key !== null && _key !== '' && _key !== undefined) {
			this.adhaarService.getAdharNumber(_key)
				.subscribe(res => {
					if (res) {
						this.adharValidation.isAadhaarVerified = true;
						this.isVerified.emit(this.adharValidation);
						this.aadharNumber = res.aadharNumber;
						// this.group.get('personalDetails').get('aadharNumber').patchValue(res.aadharNumber);
						console.log( this.group.get('personalDetails').get('aadharNumber').value);
					}
				});
		}

	}
}
